import React from 'react';
import { motion } from 'framer-motion';

export default function Reviews() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, margin: '-100px' }}
        >
          <h3 className="text-3xl font-serif text-black mb-6">Stories That Travel Beyond Borders</h3>
          <p className="text-sm text-gray-600 leading-relaxed mb-8">
            Critics call it five stars. Our couples call it the best day of their lives.
          </p>
          <button className="px-8 py-3 border border-black text-black uppercase tracking-[0.3em] text-[10px]">
            See the Rave Reviews
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, margin: '-100px' }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4"
        >
          {/* Tall image on the right grid */}
          <div className="col-span-1 row-span-2 overflow-hidden">
            <img
              src="/anant.png"
              alt="Couple celebration"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
          {/* Second image replacing the review card */}
          <div className="col-span-1 row-span-2 overflow-hidden">
            <img
              src="/random.png"
              alt="Wedding décor"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
